<cpq-breadcrumb
  [breadcrumbs]='breadcrumbs'>
</cpq-breadcrumb>
<form #form="ngForm">
  <h2 class="cald-heading">{{ headerLabel?.key | translate}}</h2>
  <div class="page-content-wrapper container-fluid">
    <div class="row grid-row">
      <div class="col-12 col-md-6 col-xxl-3">
        <p><span class="translation-field-label">{{ translationFieldLabel?.key | translate}}:</span></p>
        <span>{{translationField?.name}}</span>
      </div>
      <div class="col-12 col-md-6 col-xxl-3">
        <p><span
        class="translation-field-label">{{'UserCustomFields.Translation.DefaultLanguage' | translate}}:</span>
      </p>
      <span>{{translationField?.label}}</span>
    </div>
  </div>
</div>
<h2 class="cald-heading">{{'ItemActionsList.Multilanguage' | translate}}</h2>
@if (translationField && dictionaries) {
  <div class="page-content-wrapper container-fluid add-translation">
    @for (value of translationField.mlValues; track trackByFn(index, value); let index = $index) {
      <div class="row">
        <div class="col-12 col-md-6 col-xxl-3">
          <cpq-select #selectDictionary='ngModel' name="selectDictionary_{{index}}" [type]="2"
            [items]="getItems(value)" [(ngModel)]="value.id"
            [label]="{key: 'Dictionary', placeholder:'Admin.SelectLanguage'}" [control]="selectDictionary"
          (ngModelChange)="isTranslationEntered()" [cpqRequired]='true'></cpq-select>
        </div>
        <div class="col-12 col-md-6 col-xxl-3 input-container">
          <cpq-input-error #translation='ngModel'  [maxlength]="translationValidation ? translationValidation.maxValue : null" name="translation_{{index}}" [control]='translation'
            [(ngModel)]='value.text' [label]="{key: 'Translation value'}"
          (ngModelChange)="isTranslationEntered()" [cpqRequired]='true'></cpq-input-error>
          <span class="sap-icon remove-icon" (click)="removeTranslation(value)" title="{{'Admin.Msg.RemoveButton' | translate}}">&#xe03e;</span>
        </div>
      </div>
    }
  </div>
}
<div class="page-content-wrapper container-fluid">
  <button type="button" class="btn btn-primary fiori3-btn-primary" (click)="addTranslation()"
  [disabled]="addNewButtonDisabled">{{'Admin.CustomFields.AddNewTranslation' | translate}}</button>
</div>
</form>
@if (showSaveButton) {
  <div class="forms-footer" cpqFormFooterAutoSize>
    <div>
      <button type="button" class="btn btn-secondary fiori3-btn-secondary" [disabled]="!form.valid" (click)="save(true)">
        <span class="sap-icon">&#xe067;</span>{{'Msg.SaveAndBack' | translate}}
      </button>
    </div>
    <div>
      <button type="button" class="btn btn-primary fiori3-btn-primary" [disabled]="!form.valid"
      (click)="save()">{{ 'Admin.Msg.Save' | translate }}</button>
      <button type="button" class="btn btn-tertiary fiori3-btn-tertiary"
      [routerLink]="returnUrl?.getReturnUrl()" [queryParams]="queryParams">{{ 'Admin.Msg.CancelButton' | translate }}</button>
    </div>
  </div>
}